/* eslint-disable react-hooks/exhaustive-deps */
import InvestorsAreaGovernanceLayout from "@components/pages/investors-area-governance/investors-area-governance-layout"
import InvestorsAreaTab from "@components/pages/investors-area-governance/investors-area-tab"
import { getPageBySlug } from "lib/api"
import {
  linkInvestorDividendHistory,
  linkInvestorDividendPolicy,
  linkInvestorProspectus,
} from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact } from "src/mixins"

function DividendPolicyPage({ locale, data }) {
  const [trigger, anim] = useScrollAnim("fadeInUp", [0.125, 0.5, 0.75])
  return (
    <>
      <InvestorsAreaGovernanceLayout
        pageName="dividend"
        coverTitle={translations[`dividend_${locale}`]}
        breadcrumb={[
          {
            title: translations[`investors_area_${locale}`],
            url: linkInvestorProspectus,
          },
          { title: translations[`dividend_${locale}`] },
        ]}
        type="investor"
      >
        <InvestorsAreaTab
          tab="policy"
          listTab={[
            {
              title: translations[`dividend_policy_${locale}`],
              key: "policy",
              link: linkInvestorDividendPolicy,
            },
            {
              title: translations[`dividend_history_${locale}`],
              key: "history",
              link: linkInvestorDividendHistory,
            },
          ]}
        />
        <section className="sc-dividend-policy" ref={trigger}>
          <div className="sc-dividend-policy__content">
            {convertHtmlToReact(data[`content_${locale}`])}
          </div>
        </section>
      </InvestorsAreaGovernanceLayout>
    </>
  )
}
export default DividendPolicyPage

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const data = await getPageBySlug("dividend-policy")
  return {
    props: {
      seo: {
        title: data[`title_${locale}`] || "Dividend Policy",
      },
      page: "investors-area dividend",
      locale,
      data,
    },
    revalidate: 60,
  }
}
